import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="py-16 px-6 bg-[#F5F3F0]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h4 className="text-2xl font-light mb-4 text-[#4A4A4A]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>LUMIÈRE</h4>
            <p className="text-sm font-light text-[#6B6B6B] leading-relaxed">
              The gentle strength of contemporary women
            </p>
          </div>
          
          <div>
            <h5 className="text-sm font-light text-[#4A4A4A] tracking-wider mb-4">EXPLORE</h5>
            <div className="flex flex-col gap-3">
              <Link to="/collections" className="text-sm font-light text-[#6B6B6B] hover:text-[#C9A961] transition-colors duration-300">Collections</Link>
              <Link to="/about" className="text-sm font-light text-[#6B6B6B] hover:text-[#C9A961] transition-colors duration-300">Our Story</Link>
              <Link to="/contact" className="text-sm font-light text-[#6B6B6B] hover:text-[#C9A961] transition-colors duration-300 whitespace-nowrap">Book Appointment</Link>
            </div>
          </div>
          
          <div>
            <h5 className="text-sm font-light text-[#4A4A4A] tracking-wider mb-4">CONNECT</h5>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center text-[#6B6B6B] hover:text-[#C9A961] transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center text-[#6B6B6B] hover:text-[#C9A961] transition-colors duration-300 cursor-pointer">
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center text-[#6B6B6B] hover:text-[#C9A961] transition-colors duration-300 cursor-pointer">
                <i className="ri-pinterest-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-[#E5E5E5] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm font-light text-[#8B8B8B]">© 2025 LUMIÈRE. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm font-light text-[#8B8B8B] hover:text-[#C9A961] transition-colors duration-300">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
